<template>
    <div style="background-color: whitesmoke;">
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>        
        <CCardBody v-if="!loading" class="statistic_table_modify team_stats_table">
            <!-- <div style="font-weight: bold; font-size: 12px; color: white; background-color: rgb(83,83,83); padding-top: 20px; padding-bottom: 20px; padding-left: 10px;">Note: Goal percents calculation based on 1 goal per fixture in that time band (2 or more goals not in a time band not included)</div> -->
            <div style="font-weight: bold; font-size: 15px; padding-top: 20px;">{{ $t('Fixture') }}</div>
            <CDataTable
                :items="items1"
                :fields="fields1"
                hover
                border                
                outlined
                :loading='loading'
                style="font-size: 12px;white-space: nowrap;"
            >
                <template v-slot:thead-top="props">
                    <tr class="table_first_tr"> 
                        <th colspan="5">{{ $t('Details') }}</th>
                        <th colspan="3">{{ $t('Match Odds') }}</th>
                        <th colspan="6">{{ $t('First Half') }}</th>
                        <th colspan="2">{{ $t('Bts') }}</th>
                        <th colspan="6">{{ $t('Overs') }}</th>
                    </tr>                    
                </template>
                <template #fav_label="{item, index}">
                    <td style="border-right: outset;">
                        {{ item.fav_label_translated }}
                    </td>
                </template>
                <template #away_odds="{item, index}">
                    <td style="border-right: outset;">
                        {{ item.away_odds }}
                    </td>
                </template>
                <template #ht_under_25_odds="{item, index}">
                    <td style="border-right: outset;">
                        {{ item.ht_under_25_odds }}
                    </td>
                </template>
                <template #no_bts_odds="{item, index}">
                    <td style="border-right: outset;">
                        {{ item.no_bts_odds }}
                    </td>
                </template>
            </CDataTable>
            <div style="font-weight: bold; font-size: 15px;">{{ $t('Bookie Pts and ROI') }}</div>
            <CDataTable
                :items="items2"
                :fields="fields2"
                hover
                border                
                outlined
                :loading='loading'
                style="font-size: 12px;white-space: nowrap;"
            >
                <template v-slot:thead-top="props">
                    <tr class="table_first_tr"> 
                        <th colspan="3">{{ $t('League') }}</th>
                        <th colspan="6">{{ $t('Home') }}</th>
                        <th colspan="6">{{ $t('Draw') }}</th>
                        <th colspan="6">{{ $t('Away') }}</th>
                    </tr>
                    <tr class="table_first_tr"> 
                        <th colspan="3"></th>
                        <th colspan="3" style="background-color: #A6D8FF; color: black">{{ $t('Home Back') }}</th>
                        <th colspan="3" style="background-color: #FAC9D1; color: black">{{ $t('Home Lay') }}</th>
                        <th colspan="3" style="background-color: #A6D8FF; color: black">{{ $t('Draw Back') }}</th>
                        <th colspan="3" style="background-color: #FAC9D1; color: black">{{ $t('Draw Lay') }}</th>
                        <th colspan="3" style="background-color: #A6D8FF; color: black">{{ $t('Away Back') }}</th>
                        <th colspan="3" style="background-color: #FAC9D1; color: black">{{ $t('Away Lay') }}</th>
                    </tr>
                </template>
                <template #total_matches="{item, index}">
                    <td v-if="index == 0">
                        <a :href="'/#/statistic/matches/' + item.league_id + '/odds/' + item.fav_odds" target="_blank" class="underline-dec">{{ item.total_matches }}</a>
                    </td>
                    <td v-if="index == 1">
                        <a :href="'/#/viewevents?idlist=' + item.event_ids" target="_blank" class="underline-dec">{{ item.total_matches }}</a>
                    </td>
                    <td v-if="index == 2">
                        <a :href="'/#/viewevents?idlist=' + item.event_ids" target="_blank" class="underline-dec">{{ item.total_matches }}</a>
                    </td>
                   
                </template>
                <template #home_back_roi="{item, index}">
                    <td v-if="item.home_back_roi_col > 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(0,255,0,' + item.home_back_roi_col + ')'}">{{ item.home_back_roi }}</span>
                    </td>
                    <td v-if="item.home_back_roi_col < 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(255,0,0,' + -1 * item.home_back_roi_col + ')'}">{{ item.home_back_roi }}</span>
                    </td>
                </template>
                <template #home_lay_roi="{item, index}">
                    <td v-if="item.home_lay_roi_col > 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(0,255,0,' + item.home_lay_roi_col + ')'}">{{ item.home_lay_roi }}</span>
                    </td>
                    <td v-if="item.home_lay_roi_col < 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(255,0,0,' + -1 * item.home_lay_roi_col + ')'}">{{ item.home_lay_roi }}</span>
                    </td>
                </template>
                <template #draw_back_roi="{item, index}">
                    <td v-if="item.draw_back_roi_col > 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(0,255,0,' + item.draw_back_roi_col + ')'}">{{ item.draw_back_roi }}</span>
                    </td>
                    <td v-if="item.draw_back_roi_col < 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(255,0,0,' + -1 * item.draw_back_roi_col + ')'}">{{ item.draw_back_roi }}</span>
                    </td>
                </template>
                <template #draw_lay_roi="{item, index}">
                    <td v-if="item.draw_lay_roi_col > 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(0,255,0,' + item.draw_lay_roi_col + ')'}">{{ item.draw_lay_roi }}</span>
                    </td>
                    <td v-if="item.draw_lay_roi_col < 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(255,0,0,' + -1 * item.draw_lay_roi_col + ')'}">{{ item.draw_lay_roi }}</span>
                    </td>
                </template>
                <template #away_back_roi="{item, index}">
                    <td v-if="item.away_back_roi_col > 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(0,255,0,' + item.away_back_roi_col + ')'}">{{ item.away_back_roi }}</span>
                    </td>
                    <td v-if="item.away_back_roi_col < 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(255,0,0,' + -1 * item.away_back_roi_col + ')'}">{{ item.away_back_roi }}</span>
                    </td>
                </template>
                <template #away_lay_roi="{item, index}">
                    <td v-if="item.away_lay_roi_col > 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(0,255,0,' + item.away_lay_roi_col + ')'}">{{ item.away_lay_roi }}</span>
                    </td>
                    <td v-if="item.away_lay_roi_col < 0">
                        <span class="roi-cell" :style="{'background-color': 'rgba(255,0,0,' + -1 * item.away_lay_roi_col + ')'}">{{ item.away_lay_roi }}</span>
                    </td>
                </template>
            </CDataTable>
            <div style="margin-top: -17px !important; font-style: italic; font-size: 13px;">({{ $t("lay price is calculated by adding 3% onto back price") }})</div>
            <div style="font-weight: bold; font-size: 15px; padding-top: 17px;">{{ $t("Averages for League and Last 20, 10, 5 matches") }}</div>
            <div class="position-relative table-responsive" style="font-size: 12px;white-space: nowrap;">
                <table class="table table-hover table-bordered border">
                    <thead>
                        <tr class="table_first_tr">
                            <th colspan="3">{{ $t("League") }}</th>
                            <th colspan="3">{{ $t("Match Result %") }}</th>
                            <th colspan="3">{{ $t("Average Goals") }}</th>
                            <th colspan="2">{{ $t("To Score") }} %</th>
                            <th colspan="3">{{ $t("First Half Goals") }}</th>
                            <th colspan="3">{{ $t("Second Half Goals") }}</th>
                            <th colspan="5">{{ $t("Full Match Overs %") }}</th>
                            <th colspan="1">{{ $t("BTTS") }}</th>
                            <th colspan="6">{{ $t("Goal Time Bands") }}</th>
                            <th colspan="4">{{ $t("First To Score") }} %</th>
                        </tr>
                        <tr class="table_first_tr">
                            <th colspan="1">{{ $t("Playing") }}</th>
                            <th colspan="1">{{ $t("Team") }}</th>
                            <th colspan="1">{{ $t("Matches") }}</th>
                            <th colspan="1">{{ $t("home") }}</th>
                            <th colspan="1">{{ $t("draw") }}</th>
                            <th colspan="1">{{ $t("away") }}</th>
                            <th colspan="1">{{ $t("1st H") }}</th>
                            <th colspan="1">{{ $t("2nd H") }}</th>
                            <th colspan="1">{{ $t("total") }}</th>
                            <th colspan="1">{{ $t("home") }}</th>
                            <th colspan="1">{{ $t("away") }}</th>
                            <th colspan="1">0.5</th>
                            <th colspan="1">1.5</th>
                            <th colspan="1">2.5</th>
                            <th colspan="1">0.5</th>
                            <th colspan="1">1.5</th>
                            <th colspan="1">2.5</th>
                            <th colspan="1">0.5</th>
                            <th colspan="1">1.5</th>
                            <th colspan="1">2.5</th>
                            <th colspan="1">3.5</th>
                            <th colspan="1">4.5</th>
                            <th colspan="1">{{ $t("yes") }}</th>
                            <th colspan="1">0-15</th>
                            <th colspan="1">16-30</th>
                            <th colspan="1">31-45</th>
                            <th colspan="1">46-60</th>
                            <th colspan="1">61-75</th>
                            <th colspan="1">76-90</th>
                            <th colspan="1">{{ $t("Home") }}</th>
                            <th colspan="1">{{ $t("H Win") }}</th>
                            <th colspan="1">{{ $t("Away") }}</th>
                            <th colspan="1">{{ $t("A Win") }}</th>
                        </tr>
                    </thead>
                    <tbody class="position-relative">                    
                        <tr><td colspan="33" style="text-align: left !important; font-weight: bold; font-style: italic;">{{ $t("League Averages") }}</td></tr>
                        <tr class="background-white"> 
                            <td class=""></td>
                            <td class=""></td>
                            <td class="" style="border-right: outset;">{{ league_averages.total_matches }}</td>                            
                            <td class="">{{ league_averages.home_win_percent }}</td>
                            <td class="">{{ league_averages.draw_win_percent }}</td>
                            <td class="" style="border-right: outset;">{{ league_averages.away_win_percent }}</td>
                            <td class="">{{ league_averages.avg_firsthalf_goals_percent }}</td>
                            <td class="">{{ league_averages.avg_secondhalf_goals_percent }}</td>
                            <td :class="{'background-green' : league_averages.avg_total_goals_percent}" style="border-right: outset;">{{ league_averages.avg_total_goals_percent }}</td>
                            <td class="">{{ league_averages.home_score_percent }}</td>
                            <td class="" style="border-right: outset;">{{ league_averages.away_score_percent }}</td>
                            <td class="">{{ league_averages.first_05_percent }}</td>
                            <td class="">{{ league_averages.first_15_percent }}</td>
                            <td class="" style="border-right: outset;">{{ league_averages.first_25_percent }}</td>
                            <td class="">{{ league_averages.second_05_percent }}</td>
                            <td class="">{{ league_averages.second_15_percent }}</td>
                            <td class="" style="border-right: outset;">{{ league_averages.second_25_percent }}</td>
                            <td class="">{{ league_averages.full_05_percent }}</td>
                            <td class="">{{ league_averages.full_15_percent }}</td>
                            <td class="">{{ league_averages.full_25_percent }}</td>
                            <td class="">{{ league_averages.full_35_percent }}</td>
                            <td class="" style="border-right: outset;">{{ league_averages.full_45_percent }}</td>
                            <td class="" style="border-right: outset;">{{ league_averages.bts_percent }}</td>
                            <td class="">{{ league_averages.goal_bands_15_percent }}</td>
                            <td class="">{{ league_averages.goal_bands_30_percent }}</td>
                            <td class="">{{ league_averages.goal_bands_45_percent }}</td>
                            <td class="">{{ league_averages.goal_bands_60_percent }}</td>
                            <td class="">{{ league_averages.goal_bands_75_percent }}</td>
                            <td class="" style="border-right: outset;">{{ league_averages.goal_bands_90_percent }}</td>
                            <td class="">{{ league_averages.fts_h_percent }}</td>
                            <td class="">{{ league_averages.fts_hw_percent }}</td>
                            <td class="">{{ league_averages.fts_a_percent }}</td>
                            <td class="">{{ league_averages.fts_aw_percent }}</td>
                        </tr>
                        <tr><td colspan="33" style="text-align: left !important; font-weight: bold; font-style: italic;">{{ $t("Team Favorite (Based on start odds)") }}</td></tr>
                        <tr v-for=" item in team_strength"  class="background-white"> 
                            <td class="left_align" colspan="2">{{ item.name }}</td>
                            <td style="border-right: outset;">
                                <a v-if=" item.total_matches" :href="'/#/statistic/matches/' + item.league_id + '/odds/' + item.name" target="_blank" class="underline-dec">{{ item.total_matches }}</a>
                            </td>
                            <td class="">{{ item.home_win_percent }}</td>
                            <td class="">{{ item.draw_win_percent }}</td>
                            <td class="" style="border-right: outset;">{{ item.away_win_percent }}</td>
                            <td class="">{{ item.avg_firsthalf_goals_percent }}</td>
                            <td class="">{{ item.avg_secondhalf_goals_percent }}</td>
                            <td :class="{'background-green' : item.avg_total_goals_percent}" style="border-right: outset;">{{ item.avg_total_goals_percent }}</td>
                            <td class="">{{ item.home_score_percent }}</td>
                            <td class="" style="border-right: outset;">{{ item.away_score_percent }}</td>
                            <td class="">{{ item.first_05_percent }}</td>
                            <td class="">{{ item.first_15_percent }}</td>
                            <td class="" style="border-right: outset;">{{ item.first_25_percent }}</td>
                            <td class="">{{ item.second_05_percent }}</td>
                            <td class="">{{ item.second_15_percent }}</td>
                            <td class="" style="border-right: outset;">{{ item.second_25_percent }}</td>
                            <td class="">{{ item.full_05_percent }}</td>
                            <td class="">{{ item.full_15_percent }}</td>
                            <td class="">{{ item.full_25_percent }}</td>
                            <td class="">{{ item.full_35_percent }}</td>
                            <td class="" style="border-right: outset;">{{ item.full_45_percent }}</td>
                            <td class="" style="border-right: outset;">{{ item.bts_percent }}</td>
                            <td class="">{{ item.goal_bands_15_percent }}</td>
                            <td class="">{{ item.goal_bands_30_percent }}</td>
                            <td class="">{{ item.goal_bands_45_percent }}</td>
                            <td class="">{{ item.goal_bands_60_percent }}</td>
                            <td class="">{{ item.goal_bands_75_percent }}</td>
                            <td class="" style="border-right: outset;">{{ item.goal_bands_90_percent }}</td>
                            <td class="">{{ item.fts_h_percent }}</td>
                            <td class="">{{ item.fts_hw_percent }}</td>
                            <td class="">{{ item.fts_a_percent }}</td>
                            <td class="">{{ item.fts_aw_percent }}</td>
                        </tr>
                        <tr><td colspan="33" style="text-align: left !important; font-weight: bold; font-style: italic;">{{ $t("Last 20 matches - Long Term") }}:</td></tr>
                        <tr v-for="(item, index) in last_20_matches"  class="background-white" > 
                            <td :class="{'left_align': true, 'color-dark': index==2}" colspan="2" >{{ item.name }}</td>                            
                            <td style="border-right: outset;">
                                <a v-if="item.total_matches" :href="'/#/viewevents?idlist=' + item.event_ids" target="_blank" class="underline-dec">{{ item.total_matches }}</a>
                            </td>
                            <td :class="{'color-dark': index==2}">{{ item.home_win_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.draw_win_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.away_win_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.avg_firsthalf_goals_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.avg_secondhalf_goals_percent }}</td>
                            <td :class="{'background-green' : item.avg_total_goals_percent}" style="border-right: outset;">{{ item.avg_total_goals_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.home_score_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.away_score_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.first_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.first_15_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.first_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.second_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.second_15_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.second_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_15_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_35_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.full_45_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.bts_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_15_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_30_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_45_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_60_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_75_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.goal_bands_90_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_h_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_hw_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_a_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_aw_percent }}</td>
                        </tr>
                        <tr><td colspan="33" style="text-align: left !important; font-weight: bold; font-style: italic;">{{ $t("Last 10 matches - Medium Term") }}:</td></tr>
                        <tr v-for=" (item, index) in last_10_matches"  class="background-white"> 
                            <td :class="{'left_align': true, 'color-dark': index==2}" colspan="2">{{ item.name }}</td>                            
                            <td style="border-right: outset;">
                                <a v-if="item.total_matches" :href="'/#/viewevents?idlist=' + item.event_ids" target="_blank" class="underline-dec">{{ item.total_matches }}</a>
                            </td>
                            <td :class="{'color-dark': index==2}">{{ item.home_win_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.draw_win_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.away_win_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.avg_firsthalf_goals_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.avg_secondhalf_goals_percent }}</td>
                            <td :class="{'background-green' : item.avg_total_goals_percent}" style="border-right: outset;">{{ item.avg_total_goals_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.home_score_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.away_score_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.first_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.first_15_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.first_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.second_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.second_15_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.second_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_15_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_35_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.full_45_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.bts_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_15_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_30_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_45_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_60_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_75_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.goal_bands_90_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_h_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_hw_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_a_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_aw_percent }}</td>
                        </tr>
                        <tr><td colspan="33" style="text-align: left !important; font-weight: bold; font-style: italic;">{{ $t("Last 5 matches - Short Term") }}:</td></tr>
                        <tr v-for=" (item, index) in last_5_matches"  class="background-white"> 
                            <td :class="{'left_align': true, 'color-dark': index==2}" colspan="2">{{ item.name }}</td>                            
                            <td style="border-right: outset;">
                                <a v-if="item.total_matches" :href="'/#/viewevents?idlist=' + item.event_ids" target="_blank" class="underline-dec">{{ item.total_matches }}</a>
                            </td>
                            <td :class="{'color-dark': index==2}">{{ item.home_win_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.draw_win_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.away_win_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.avg_firsthalf_goals_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.avg_secondhalf_goals_percent }}</td>
                            <td :class="{'background-green' : item.avg_total_goals_percent}" style="border-right: outset;">{{ item.avg_total_goals_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.home_score_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.away_score_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.first_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.first_15_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.first_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.second_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.second_15_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.second_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_05_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_15_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_25_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.full_35_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.full_45_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.bts_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_15_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_30_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_45_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_60_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.goal_bands_75_percent }}</td>
                            <td :class="{'color-dark': index==2}" style="border-right: outset;">{{ item.goal_bands_90_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_h_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_hw_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_a_percent }}</td>
                            <td :class="{'color-dark': index==2}">{{ item.fts_aw_percent }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>


        </CCardBody>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { Plotly } from 'vue-plotly'
import swal from "sweetalert2";
import {convertUTCToLocal} from '../helpers/time';

export default {
    name: 'investments',
    components: {
        Plotly,
       
    },
    data () {
        return {            
            items1: [],
            items2: [],
            fields1: [
                { key: 'startingAt', label: this.$t('Time ')},
                { key: 'league', label: this.$t('League')},
                { key: 'event', label: this.$t('Match')},
                { key: 'leaguePos', label: this.$t('League Pos')},
                { key: 'fav_label', label: this.$t('Fav Label')},
                { key: 'home_odds', label: this.$t('Home')},
                { key: 'draw_odds', label: this.$t('Draw')},
                { key: 'away_odds', label: this.$t('Away')},
                { key: 'ht_over_05_odds', label: this.$t('O0.5')},
                { key: 'ht_under_05_odds', label: this.$t('U0.5')},
                { key: 'ht_over_15_odds', label: this.$t('O1.5')},
                { key: 'ht_under_15_odds', label: this.$t('U1.5')},
                { key: 'ht_over_25_odds', label: this.$t('O2.5')},
                { key: 'ht_under_25_odds', label: this.$t('U2.5')},
                { key: 'bts_odds', label: this.$t('Yes')},
                { key: 'no_bts_odds', label: this.$t('No')},
                { key: 'over_15_odds', label: this.$t('O1.5')},
                { key: 'under_15_odds', label: this.$t('U1.5')},
                { key: 'over_25_odds', label: this.$t('O2.5')},
                { key: 'under_25_odds', label: this.$t('U2.5')},
                { key: 'over_35_odds', label: this.$t('O3.5')},
                { key: 'under_35_odds', label: this.$t('U3.5')},
            ],
            fields2: [
                { key: 'label', label: this.$t('Label'),},
                { key: 'fav_odds_label', label: this.$t('Odds')},
                { key: 'total_matches', label: this.$t('Matches')},
                { key: 'home_back_win', label: this.$t('Win%'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'home_back_pts', label: this.$t('Pts'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'home_back_roi', label: this.$t('Roi'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'home_lay_win', label: this.$t('Win%'), _style: "background-color: #FAC9D1; color: black"},
                { key: 'home_lay_pts', label: this.$t('Pts'), _style: "background-color: #FAC9D1; color: black"},
                { key: 'home_lay_roi', label: this.$t('Roi'), _style: "background-color: #FAC9D1; color: black"},
                { key: 'draw_back_win', label: this.$t('Win%'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'draw_back_pts', label: this.$t('Pts'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'draw_back_roi', label: this.$t('Roi'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'draw_lay_win', label: this.$t('Win%'), _style: "background-color: #FAC9D1; color: black"},
                { key: 'draw_lay_pts', label: this.$t('Pts'), _style: "background-color: #FAC9D1; color: black"},
                { key: 'draw_lay_roi', label: this.$t('Roi'), _style: "background-color: #FAC9D1; color: black"},
                { key: 'away_back_win', label: this.$t('Win%'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'away_back_pts', label: this.$t('Pts'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'away_back_roi', label: this.$t('Roi'), _style: "background-color: #A6D8FF; color: black"},
                { key: 'away_lay_win', label: this.$t('Win%'), _style: "background-color: #FAC9D1; color: black"},
                { key: 'away_lay_pts', label: this.$t('Pts'), _style: "background-color: #FAC9D1; color: black"},
                { key: 'away_lay_roi', label: this.$t('Roi'), _style: "background-color: #FAC9D1; color: black"},
            ],
            league_averages: {
                total_matches: '',
                home_win_percent: '',
                draw_win_percent: '',
                away_win_percent: '',
                avg_firsthalf_goals_percent: '',
                avg_secondhalf_goals_percent: '',
                avg_total_goals_percent: '',
                home_score_percent: '',
                away_score_percent: '',
                first_05_percent: '',
                first_15_percent: '',
                first_25_percent: '',
                second_05_percent: '',
                second_15_percent: '',
                second_25_percent: '',
                full_05_percent: '',
                full_15_percent: '',
                full_25_percent: '',
                full_35_percent: '',
                full_45_percent: '',
                bts_percent: '',
                goal_bands_15_percent: '',
                goal_bands_30_percent: '',
                goal_bands_45_percent: '',
                goal_bands_60_percent: '',
                goal_bands_75_percent: '',
                goal_bands_90_percent: '',
                fts_h_percent: '',
                fts_hw_percent: '',
                fts_a_percent: '',
                fts_aw_percent: '',
            },

            team_strength: [
                {
                    name: '',
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: '',
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                }
            ],
            last_20_matches: [
                {
                    name: this.$t('home'),
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t('away'),
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t('Chance') + ":",
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t("Implied Odds")+":",
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                }
            ],
            last_10_matches: [
                {
                    name: this.$t('home'),
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t('away'),
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t('Chance') + ":",
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t("Implied Odds")+":",
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                }
            ],
            last_5_matches: [
                {
                    name: this.$t('home'),
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t('away'),
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t('Chance') + ":",
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                },
                {
                    name: this.$t("Implied Odds")+":",
                    total_matches: '',
                    home_win_percent: '',
                    draw_win_percent: '',
                    away_win_percent: '',
                    avg_firsthalf_goals_percent: '',
                    avg_secondhalf_goals_percent: '',
                    avg_total_goals_percent: '',
                    home_score_percent: '',
                    away_score_percent: '',
                    first_05_percent: '',
                    first_15_percent: '',
                    first_25_percent: '',
                    second_05_percent: '',
                    second_15_percent: '',
                    second_25_percent: '',
                    full_05_percent: '',
                    full_15_percent: '',
                    full_25_percent: '',
                    full_35_percent: '',
                    full_45_percent: '',
                    bts_percent: '',
                    goal_bands_15_percent: '',
                    goal_bands_30_percent: '',
                    goal_bands_45_percent: '',
                    goal_bands_60_percent: '',
                    goal_bands_75_percent: '',
                    goal_bands_90_percent: '',
                    fts_h_percent: '',
                    fts_hw_percent: '',
                    fts_a_percent: '',
                    fts_aw_percent: '',
                }
            ],
            loading: true
        }
    },
    created() {
        
    },
    mounted: function (){
        this.$nextTick(function () {
            this.set_items();

        })
    },
    methods: {
        ...mapActions([
            'getTeams5YearStatsDetail'            
        ]),
        set_items() {
            this.items1 = [];
            this.items2 = [];
            let eventId = `${this.$route.params.eventId}`;

            this.showModal();
            this.getTeams5YearStatsDetail({eventId: parseInt(eventId)}).then((data) => {                
                let items1 = [];
                let items2 = [];
                if (data.fResults) {
                    let _home5yearsStats = data.home5yearsStats;
                    let _away5yearsStats = data.away5yearsStats;
                    let _league5yearsStats = data.league5yearsStats;
                    let _livePageMarkets_pre = data.livePageMarkets_pre;
                    let _league5yearsStats_ = data.league5yearsStats_;
                
                    for (let event of data.fResults) {
                        // start of Fixture
                        let eItem = {
                            'startingAt': '',
                            'league': '',
                            'event': '',
                            'leaguePos': '',
                            'fav_label': '',
                            'home_odds': '',
                            'draw_odds': '',
                            'away_odds': '',
                            'ht_under_05_odds': '',
                            'ht_over_05_odds': '',
                            'ht_under_15_odds': '',
                            'ht_over_15_odds': '',
                            'ht_under_25_odds': '',
                            'ht_over_25_odds': '',
                            'no_bts_odds': '',
                            'bts_odds': '',
                            'under_15_odds': '',
                            'over_15_odds': '',
                            'under_25_odds': '',
                            'over_25_odds': '',
                            'under_35_odds': '',
                            'over_35_odds': '',
                        };

                        let _eItem = {
                            'startingAt': '',
                            'league': '',
                            'event': '',
                            'leaguePos': '',
                            'fav_label': this.$t('Implied Odds') + ":",
                            'home_odds': '',
                            'draw_odds': '',
                            'away_odds': '',
                            'ht_under_05_odds': '',
                            'ht_over_05_odds': '',
                            'ht_under_15_odds': '',
                            'ht_over_15_odds': '',
                            'ht_under_25_odds': '',
                            'ht_over_25_odds': '',
                            'no_bts_odds': '',
                            'bts_odds': '',
                            'under_15_odds': '',
                            'over_15_odds': '',
                            'under_25_odds': '',
                            'over_25_odds': '',
                            'under_35_odds': '',
                            'over_35_odds': '',
                        };

                        let _id = event._id;
                        let leagueId = event.leagueId;
                        let round_id = event.round_id;

                        let home5yearsStats = _home5yearsStats.filter( item => item.team_id == event.localTeamId && item.league_id == leagueId);
                        let away5yearsStats = _away5yearsStats.filter( item => item.team_id == event.visitorTeamId && item.league_id == leagueId);
                        let league5yearsStats = _league5yearsStats.filter( item => item.league_id == leagueId);                        
                        let livePageMarkets_pre = _livePageMarkets_pre.filter( item => item.fixtureId == _id);
                        let league5yearsStats_ = _league5yearsStats_.filter( item => item.league_id == leagueId);


                        let startingAt = convertUTCToLocal(event.time.starting_at.date_time);
                        // eItem['startingAt'] = startingAt.toLocaleDateString() + ' ' + startingAt.toLocaleTimeString();
                        eItem['startingAt'] = startingAt.toLocaleTimeString();

                        if (league5yearsStats.length > 0) {
                            let country = league5yearsStats[0].country_name;
                            let league_name = league5yearsStats[0].league_name;
                            eItem["league"] = country + " " + league_name;                            
                        }
                        eItem["event"] = event.localTeamName + " v " + event.visitorTeamName;

                        //match odds, 0.5HT, O/U 2.5, BTS
                        for (let odd of livePageMarkets_pre) {
                            if(odd.marketType === "MATCH_ODDS"){
                                if(odd.runners){
                                    if(odd.runners[0]){
                                        let runnerNode = odd.runners[0];
                                        if(runnerNode.exchange){
                                            if(runnerNode.exchange.availableToBack){
                                                if(runnerNode.exchange.availableToBack[0]){
                                                    eItem["home_odds"] = runnerNode.exchange.availableToBack[0].price;
                                                    _eItem["home_odds"] = (100 / eItem["home_odds"]).toFixed(2);
                                                }
                                            }
                                        }
                                    }
                                    if(odd.runners[1]){
                                        let runnerNode1 = odd.runners[2];
                                        if(runnerNode1.exchange){
                                            if(runnerNode1.exchange.availableToBack){
                                                if(runnerNode1.exchange.availableToBack[0]){
                                                    eItem["draw_odds"] = runnerNode1.exchange.availableToBack[0].price;
                                                    _eItem["draw_odds"] = (100 / eItem["draw_odds"]).toFixed(2);
                                                }
                                            }
                                        }
                                    }
                                    if(odd.runners[2]){
                                        let runnerNode2 = odd.runners[1];
                                        if(runnerNode2.exchange){
                                            if(runnerNode2.exchange.availableToBack){
                                                if(runnerNode2.exchange.availableToBack[0]){
                                                    eItem["away_odds"] = runnerNode2.exchange.availableToBack[0].price;
                                                    _eItem["away_odds"] = (100 / eItem["away_odds"]).toFixed(2);
                                                }
                                            }
                                        }
                                    }
                                }                               
                            }
                            else if (odd.marketType === "FIRST_HALF_GOALS_05" ||odd.marketType === "FIRST_HALF_GOALS_15" || odd.marketType === "FIRST_HALF_GOALS_25" || odd.marketType === "OVER_UNDER_15" || odd.marketType === "OVER_UNDER_25" || odd.marketType === "OVER_UNDER_35" || odd.marketType === "BOTH_TEAMS_TO_SCORE"){
                                if(odd.runners && odd.runners.length > 0){
                                    let runnerNode = odd.runners[0];
                                    if(runnerNode.exchange){
                                        if(runnerNode.exchange.availableToBack){
                                            if(runnerNode.exchange.availableToBack[0]){
                                                let odd_price = runnerNode.exchange.availableToBack[0].price;
                                                if (odd.marketType === "FIRST_HALF_GOALS_05") {
                                                    eItem["ht_under_05_odds"] = odd_price;
                                                    _eItem["ht_under_05_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                                else if (odd.marketType === "FIRST_HALF_GOALS_15") {
                                                    eItem["ht_under_15_odds"] = odd_price;
                                                    _eItem["ht_under_15_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                                else if (odd.marketType === "FIRST_HALF_GOALS_25") {
                                                    _eItem["ht_under_25_odds"] = (100 / odd_price).toFixed(2);
                                                    eItem["ht_under_25_odds"] = odd_price;
                                                }
                                                else if (odd.marketType === "OVER_UNDER_15") {
                                                    _eItem["under_15_odds"] = (100 / odd_price).toFixed(2);
                                                    eItem["under_15_odds"] = odd_price;
                                                }
                                                else if (odd.marketType === "OVER_UNDER_25") {
                                                    _eItem["under_25_odds"] = (100 / odd_price).toFixed(2);
                                                    eItem["under_25_odds"] = odd_price;
                                                }
                                                else if (odd.marketType === "OVER_UNDER_35") {
                                                    _eItem["under_35_odds"] = (100 / odd_price).toFixed(2);
                                                    eItem["under_35_odds"] = odd_price;
                                                }
                                                else if (odd.marketType === "BOTH_TEAMS_TO_SCORE") {
                                                    // _eItem["no_bts_odds"] = (100 / odd_price).toFixed(2);
                                                    // eItem["no_bts_odds"] = odd_price;
                                                    eItem["bts_odds"] = odd_price;
                                                    _eItem["bts_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                            }
                                        }
                                    }
                                }
                                if(odd.runners && odd.runners.length > 1){
                                    let runnerNode1 = odd.runners[1];
                                    if(runnerNode1.exchange){
                                        if(runnerNode1.exchange.availableToBack){
                                            if(runnerNode1.exchange.availableToBack[0]){
                                                let odd_price = runnerNode1.exchange.availableToBack[0].price;
                                                if (odd.marketType === "FIRST_HALF_GOALS_05") {
                                                    eItem["ht_over_05_odds"] = odd_price;
                                                    _eItem["ht_over_05_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                                else if (odd.marketType === "FIRST_HALF_GOALS_15") {
                                                    eItem["ht_over_15_odds"] = odd_price;
                                                    _eItem["ht_over_15_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                                else if (odd.marketType === "FIRST_HALF_GOALS_25") {
                                                    eItem["ht_over_25_odds"] = odd_price;
                                                    _eItem["ht_over_25_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                                else if (odd.marketType === "OVER_UNDER_15") {
                                                    eItem["over_15_odds"] = odd_price;
                                                    _eItem["over_15_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                                else if (odd.marketType === "OVER_UNDER_25") {
                                                    eItem["over_25_odds"] = odd_price;
                                                    _eItem["over_25_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                                else if (odd.marketType === "OVER_UNDER_35") {
                                                    eItem["over_35_odds"] = odd_price;
                                                    _eItem["over_35_odds"] = (100 / odd_price).toFixed(2);
                                                }
                                                else if (odd.marketType === "BOTH_TEAMS_TO_SCORE") {
                                                    // eItem["bts_odds"] = odd_price;
                                                    // _eItem["bts_odds"] = (100 / odd_price).toFixed(2);
                                                    _eItem["no_bts_odds"] = (100 / odd_price).toFixed(2);
                                                    eItem["no_bts_odds"] = odd_price;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let fav_odds;
                        let fav_odds_label;
                        if (eItem["home_odds"] && eItem["away_odds"]) {                        
                            if (eItem["home_odds"] <= 3 && eItem["away_odds"] <= 3) {
                                fav_odds = "SuperCompetative";
                                fav_odds_label = "[H-A<3]";
                            }
                            else if (eItem["home_odds"] <= 1.5) {
                                fav_odds = "H_StrongFav";
                                fav_odds_label = "[H<1.5]";
                            }
                            else if (eItem["home_odds"] > 1.5 && eItem["home_odds"] <= 2) {
                                fav_odds = "H_MediumFav";
                                fav_odds_label = "[1.5>H<2]";
                            }
                            else if (eItem["home_odds"] > 2 && eItem["home_odds"] <= 3) {
                                fav_odds = "H_SmallFav";
                                fav_odds_label = "[2>H<3]";
                            }
                            
                            else if (eItem["away_odds"] <= 1.5) {
                                fav_odds = "A_StrongFav";
                                fav_odds_label = "[A<1.5]";
                            }
                            else if (eItem["away_odds"] > 1.5 && eItem["away_odds"] <= 2) {
                                fav_odds = "A_MediumFav";
                                fav_odds_label = "[1.5>A<2]";
                            }
                            else if (eItem["away_odds"] > 2 && eItem["away_odds"] <= 3) {
                                fav_odds = "A_SmallFav";
                                fav_odds_label = "[2>A<3]";
                            }
                        }
                        if (fav_odds) {
                            eItem["fav_label"] = fav_odds; // Use original value for logic
                            // Add the static translation logic here
                            const translations = {
                                "SuperCompetative": this.$t("Equilibrata"),
                                "A_MediumFav": this.$t("Ospite_med_fav"),
                                "A_SmallFav": this.$t("Ospite_min_fav"),
                                "H_MediumFav": this.$t("Casa_med_fav"),
                                "H_SmallFav": this.$t("Casa_min_fav"),
                                "A_StrongFav": this.$t("Ospite_max_fav"),
                                "H_StrongFav": this.$t("Casa_max_fav"),
                            };

                            // Translate the label
                            eItem["fav_label_translated"] = translations[fav_odds] || fav_odds;
                        }
                        items1.push(eItem);
                        items1.push(_eItem);

                        // end of Fixture

                        // start of Bookie Pts and ROI
                        let homeStats;
                        let awayStats;
                        let leagueStats;
                        
                        if (home5yearsStats.length > 0) {
                            homeStats = home5yearsStats[0].as_home;
                        }
                        if (away5yearsStats.length > 0) {
                            awayStats = away5yearsStats[0].as_away;
                        }
                        if (league5yearsStats.length > 0) {
                            leagueStats = league5yearsStats[0].as_league;
                        }                       
                        
                        if (fav_odds) {
                            if (leagueStats) {
                                let total_matches = leagueStats[fav_odds]["total_matches"];
                                let home_back_win = Number((leagueStats[fav_odds]["home_back"].win_matches / total_matches * 100).toFixed(2));
                                let home_lay_win = (100 - home_back_win).toFixed(2);
                                let draw_back_win = Number((leagueStats[fav_odds]["draw_back"].win_matches / total_matches * 100).toFixed(2));
                                let draw_lay_win = (100 - draw_back_win).toFixed(2);
                                let away_back_win = Number((leagueStats[fav_odds]["away_back"].win_matches / total_matches * 100).toFixed(2));
                                let away_lay_win = (100 - away_back_win).toFixed(2);
                                items2.push({
                                    'label': 'League',
                                    'fav_odds': fav_odds,
                                    'league_id': leagueId,
                                    'fav_odds_label': fav_odds_label,
                                    'total_matches': total_matches,
                                    'home_back_win': home_back_win,
                                    'home_back_pts': leagueStats[fav_odds]["home_back"].pts.toFixed(2),
                                    'home_back_roi': leagueStats[fav_odds]["home_back"].roi.toFixed(2),
                                    'home_lay_win': home_lay_win,
                                    'home_lay_pts': leagueStats[fav_odds]["home_lay"].pts.toFixed(2),
                                    'home_lay_roi': leagueStats[fav_odds]["home_lay"].roi.toFixed(2),
                                    'draw_back_win': draw_back_win,
                                    'draw_back_pts': leagueStats[fav_odds]["draw_back"].pts.toFixed(2),
                                    'draw_back_roi': leagueStats[fav_odds]["draw_back"].roi.toFixed(2),
                                    'draw_lay_win': draw_lay_win,
                                    'draw_lay_pts': leagueStats[fav_odds]["draw_lay"].pts.toFixed(2),
                                    'draw_lay_roi': leagueStats[fav_odds]["draw_lay"].roi.toFixed(2),
                                    'away_back_win': away_back_win,
                                    'away_back_pts': leagueStats[fav_odds]["away_back"].pts.toFixed(2),
                                    'away_back_roi': leagueStats[fav_odds]["away_back"].roi.toFixed(2),
                                    'away_lay_win': away_lay_win,
                                    'away_lay_pts': leagueStats[fav_odds]["away_lay"].pts.toFixed(2),
                                    'away_lay_roi': leagueStats[fav_odds]["away_lay"].roi.toFixed(2),

                                    'home_back_roi_col': leagueStats[fav_odds]["home_back"].roi / 50,
                                    'home_lay_roi_col': leagueStats[fav_odds]["home_lay"].roi / 50,
                                    'draw_back_roi_col': leagueStats[fav_odds]["draw_back"].roi / 50,
                                    'draw_lay_roi_col': leagueStats[fav_odds]["draw_lay"].roi / 50,
                                    'away_back_roi_col': leagueStats[fav_odds]["away_back"].roi / 50,
                                    'away_lay_roi_col': leagueStats[fav_odds]["away_lay"].roi / 50,
                                });
                            }
                            if (homeStats) {
                                let total_matches = homeStats[fav_odds]["total_matches"];
                                let home_back_win = Number((homeStats[fav_odds]["home_back"].win_matches / total_matches * 100).toFixed(2));
                                let home_lay_win = (100 - home_back_win).toFixed(2);
                                let draw_back_win = Number((homeStats[fav_odds]["draw_back"].win_matches / total_matches * 100).toFixed(2));
                                let draw_lay_win = (100 - draw_back_win).toFixed(2);
                                let away_back_win = Number((homeStats[fav_odds]["away_back"].win_matches / total_matches * 100).toFixed(2));
                                let away_lay_win = (100 - away_back_win).toFixed(2);
                                items2.push({
                                    'label': event.localTeamName,
                                    'fav_odds_label': fav_odds_label,
                                    'total_matches': total_matches,
                                    'home_back_win': home_back_win,
                                    'home_back_pts': homeStats[fav_odds]["home_back"].pts.toFixed(2),
                                    'home_back_roi': homeStats[fav_odds]["home_back"].roi.toFixed(2),
                                    'home_lay_win': home_lay_win,
                                    'home_lay_pts': homeStats[fav_odds]["home_lay"].pts.toFixed(2),
                                    'home_lay_roi': homeStats[fav_odds]["home_lay"].roi.toFixed(2),
                                    'draw_back_win': draw_back_win,
                                    'draw_back_pts': homeStats[fav_odds]["draw_back"].pts.toFixed(2),
                                    'draw_back_roi': homeStats[fav_odds]["draw_back"].roi.toFixed(2),
                                    'draw_lay_win': draw_lay_win,
                                    'draw_lay_pts': homeStats[fav_odds]["draw_lay"].pts.toFixed(2),
                                    'draw_lay_roi': homeStats[fav_odds]["draw_lay"].roi.toFixed(2),
                                    'away_back_win': away_back_win,
                                    'away_back_pts': homeStats[fav_odds]["away_back"].pts.toFixed(2),
                                    'away_back_roi': homeStats[fav_odds]["away_back"].roi.toFixed(2),
                                    'away_lay_win': away_lay_win,
                                    'away_lay_pts': homeStats[fav_odds]["away_lay"].pts.toFixed(2),
                                    'away_lay_roi': homeStats[fav_odds]["away_lay"].roi.toFixed(2),
                                    'event_ids': homeStats[fav_odds].event_ids,

                                    'home_back_roi_col': homeStats[fav_odds]["home_back"].roi / 50,
                                    'home_lay_roi_col': homeStats[fav_odds]["home_lay"].roi / 50,
                                    'draw_back_roi_col': homeStats[fav_odds]["draw_back"].roi / 50,
                                    'draw_lay_roi_col': homeStats[fav_odds]["draw_lay"].roi / 50,
                                    'away_back_roi_col': homeStats[fav_odds]["away_back"].roi / 50,
                                    'away_lay_roi_col': homeStats[fav_odds]["away_lay"].roi / 50,
                                });
                            }
                            if (awayStats) {
                                let total_matches = awayStats[fav_odds]["total_matches"];
                                let home_back_win = Number((awayStats[fav_odds]["home_back"].win_matches / total_matches * 100).toFixed(2));
                                let home_lay_win = (100 - home_back_win).toFixed(2);
                                let draw_back_win = Number((awayStats[fav_odds]["draw_back"].win_matches / total_matches * 100).toFixed(2));
                                let draw_lay_win = (100 - draw_back_win).toFixed(2);
                                let away_back_win = Number((awayStats[fav_odds]["away_back"].win_matches / total_matches * 100).toFixed(2));
                                let away_lay_win = (100 - away_back_win).toFixed(2);
                                items2.push({
                                    'label': event.visitorTeamName,
                                    'fav_odds_label': fav_odds_label,
                                    'total_matches': total_matches,
                                    'home_back_win': home_back_win,
                                    'home_back_pts': awayStats[fav_odds]["home_back"].pts.toFixed(2),
                                    'home_back_roi': awayStats[fav_odds]["home_back"].roi.toFixed(2),
                                    'home_lay_win': home_lay_win,
                                    'home_lay_pts': awayStats[fav_odds]["home_lay"].pts.toFixed(2),
                                    'home_lay_roi': awayStats[fav_odds]["home_lay"].roi.toFixed(2),
                                    'draw_back_win': draw_back_win,
                                    'draw_back_pts': awayStats[fav_odds]["draw_back"].pts.toFixed(2),
                                    'draw_back_roi': awayStats[fav_odds]["draw_back"].roi.toFixed(2),
                                    'draw_lay_win': draw_lay_win,
                                    'draw_lay_pts': awayStats[fav_odds]["draw_lay"].pts.toFixed(2),
                                    'draw_lay_roi': awayStats[fav_odds]["draw_lay"].roi.toFixed(2),
                                    'away_back_win': away_back_win,
                                    'away_back_pts': awayStats[fav_odds]["away_back"].pts.toFixed(2),
                                    'away_back_roi': awayStats[fav_odds]["away_back"].roi.toFixed(2),
                                    'away_lay_win': away_lay_win,
                                    'away_lay_pts': awayStats[fav_odds]["away_lay"].pts.toFixed(2),
                                    'away_lay_roi': awayStats[fav_odds]["away_lay"].roi.toFixed(2),
                                    'event_ids': awayStats[fav_odds].event_ids,
                                    
                                    'home_back_roi_col': awayStats[fav_odds]["home_back"].roi / 50,
                                    'home_lay_roi_col': awayStats[fav_odds]["home_lay"].roi / 50,
                                    'draw_back_roi_col': awayStats[fav_odds]["draw_back"].roi / 50,
                                    'draw_lay_roi_col': awayStats[fav_odds]["draw_lay"].roi / 50,
                                    'away_back_roi_col': awayStats[fav_odds]["away_back"].roi / 50,
                                    'away_lay_roi_col': awayStats[fav_odds]["away_lay"].roi / 50,
                                });
                            }
                        }



                        // league aerages
                        if (league5yearsStats_.length > 0) {
                            eItem.leaguePos = league5yearsStats_[0].tier;
                            this.league_averages = {
                                total_matches: league5yearsStats_[0].total_matches,
                                home_win_percent: league5yearsStats_[0].home_win_percent,
                                draw_win_percent: league5yearsStats_[0].draw_win_percent,
                                away_win_percent: league5yearsStats_[0].away_win_percent,
                                avg_firsthalf_goals_percent: league5yearsStats_[0].avg_firsthalf_goals_percent,
                                avg_secondhalf_goals_percent: league5yearsStats_[0].avg_secondhalf_goals_percent,
                                avg_total_goals_percent: league5yearsStats_[0].avg_total_goals_percent,
                                home_score_percent: league5yearsStats_[0].home_score_percent,
                                away_score_percent: league5yearsStats_[0].away_score_percent,
                                first_05_percent: league5yearsStats_[0].first_05_percent,
                                first_15_percent: league5yearsStats_[0].first_15_percent,
                                first_25_percent: league5yearsStats_[0].first_25_percent,
                                second_05_percent: league5yearsStats_[0].second_05_percent,
                                second_15_percent: league5yearsStats_[0].second_15_percent,
                                second_25_percent: league5yearsStats_[0].second_25_percent,
                                full_05_percent: league5yearsStats_[0].full_05_percent,
                                full_15_percent: league5yearsStats_[0].full_15_percent,
                                full_25_percent: league5yearsStats_[0].full_25_percent,
                                full_35_percent: league5yearsStats_[0].full_35_percent,
                                full_45_percent: league5yearsStats_[0].full_45_percent,
                                bts_percent: league5yearsStats_[0].bts_percent,
                                goal_bands_15_percent: league5yearsStats_[0].goal_bands_15_percent,
                                goal_bands_30_percent: league5yearsStats_[0].goal_bands_30_percent,
                                goal_bands_45_percent: league5yearsStats_[0].goal_bands_45_percent,
                                goal_bands_60_percent: league5yearsStats_[0].goal_bands_60_percent,
                                goal_bands_75_percent: league5yearsStats_[0].goal_bands_75_percent,
                                goal_bands_90_percent: league5yearsStats_[0].goal_bands_90_percent,
                                fts_h_percent: league5yearsStats_[0].fts_h_percent,
                                fts_hw_percent: league5yearsStats_[0].fts_hw_percent,
                                fts_a_percent: league5yearsStats_[0].fts_a_percent,
                                fts_aw_percent: league5yearsStats_[0].fts_aw_percent,
                            };
                        }

                        // team strength
                        if (fav_odds && league5yearsStats_.length > 0) {
                            let oddslines = league5yearsStats_[0].oddslines;
                            oddslines = oddslines.filter(item => item.name == fav_odds);
                            if (oddslines.length > 0) {
                                let oddsline = oddslines[0];
                                const translations = {
                                    "SuperCompetative": this.$t("Equilibrata"),
                                    "A_MediumFav": this.$t("Ospite_med_fav"),
                                    "A_SmallFav": this.$t("Ospite_min_fav"),
                                    "H_MediumFav": this.$t("Casa_med_fav"),
                                    "H_SmallFav": this.$t("Casa_min_fav"),
                                    "A_StrongFav": this.$t("Ospite_max_fav"),
                                    "H_StrongFav": this.$t("Casa_max_fav"),
                                };
                                const translatedLabel = translations[fav_odds] || fav_odds;

                                this.team_strength = [
                                    {
                                        name: translatedLabel,
                                        league_id: leagueId,
                                        total_matches: oddsline.total_matches,
                                        home_win_percent: oddsline.home_win_percent,
                                        draw_win_percent: oddsline.draw_win_percent,
                                        away_win_percent: oddsline.away_win_percent,
                                        avg_firsthalf_goals_percent: oddsline.avg_firsthalf_goals_percent,
                                        avg_secondhalf_goals_percent: oddsline.avg_secondhalf_goals_percent,
                                        avg_total_goals_percent: oddsline.avg_total_goals_percent,
                                        home_score_percent: oddsline.home_score_percent,
                                        away_score_percent: oddsline.away_score_percent,
                                        first_05_percent: oddsline.first_05_percent,
                                        first_15_percent: oddsline.first_15_percent,
                                        first_25_percent: oddsline.first_25_percent,
                                        second_05_percent: oddsline.second_05_percent,
                                        second_15_percent: oddsline.second_15_percent,
                                        second_25_percent: oddsline.second_25_percent,
                                        full_05_percent: oddsline.full_05_percent,
                                        full_15_percent: oddsline.full_15_percent,
                                        full_25_percent: oddsline.full_25_percent,
                                        full_35_percent: oddsline.full_35_percent,
                                        full_45_percent: oddsline.full_45_percent,
                                        bts_percent: oddsline.bts_percent,
                                        goal_bands_15_percent: oddsline.goal_bands_15_percent,
                                        goal_bands_30_percent: oddsline.goal_bands_30_percent,
                                        goal_bands_45_percent: oddsline.goal_bands_45_percent,
                                        goal_bands_60_percent: oddsline.goal_bands_60_percent,
                                        goal_bands_75_percent: oddsline.goal_bands_75_percent,
                                        goal_bands_90_percent: oddsline.goal_bands_90_percent,
                                        fts_h_percent: oddsline.fts_h_percent,
                                        fts_hw_percent: oddsline.fts_hw_percent,
                                        fts_a_percent: oddsline.fts_a_percent,
                                        fts_aw_percent: oddsline.fts_aw_percent,
                                    },
                                    {
                                        name: this.$t("Implied Odds") + ":",
                                        total_matches: '',
                                        home_win_percent: (100 / oddsline.home_win_percent).toFixed(2),
                                        draw_win_percent: (100 / oddsline.draw_win_percent).toFixed(2),
                                        away_win_percent: (100 / oddsline.away_win_percent).toFixed(2),
                                        avg_firsthalf_goals_percent: '',
                                        avg_secondhalf_goals_percent: '',
                                        avg_total_goals_percent: '',
                                        home_score_percent: (100 / oddsline.home_score_percent).toFixed(2),
                                        away_score_percent: (100 / oddsline.away_score_percent).toFixed(2),
                                        first_05_percent: (100 / oddsline.first_05_percent).toFixed(2),
                                        first_15_percent: (100 / oddsline.first_15_percent).toFixed(2),
                                        first_25_percent: (100 / oddsline.first_25_percent).toFixed(2),
                                        second_05_percent: (100 / oddsline.second_05_percent).toFixed(2),
                                        second_15_percent: (100 / oddsline.second_15_percent).toFixed(2),
                                        second_25_percent: (100 / oddsline.second_25_percent).toFixed(2),
                                        full_05_percent: (100 / oddsline.full_05_percent).toFixed(2),
                                        full_15_percent: (100 / oddsline.full_15_percent).toFixed(2),
                                        full_25_percent: (100 / oddsline.full_25_percent).toFixed(2),
                                        full_35_percent: (100 / oddsline.full_35_percent).toFixed(2),
                                        full_45_percent: (100 / oddsline.full_45_percent).toFixed(2),
                                        bts_percent: (100 / oddsline.bts_percent).toFixed(2),
                                        goal_bands_15_percent: '',
                                        goal_bands_30_percent: '',
                                        goal_bands_45_percent: '',
                                        goal_bands_60_percent: '',
                                        goal_bands_75_percent: '',
                                        goal_bands_90_percent: '',
                                        fts_h_percent: (100 / oddsline.fts_h_percent).toFixed(2),
                                        fts_hw_percent: (100 / oddsline.fts_hw_percent).toFixed(2),
                                        fts_a_percent: (100 / oddsline.fts_a_percent).toFixed(2),
                                        fts_aw_percent: (100 / oddsline.fts_aw_percent).toFixed(2),
                                    }
                                ];
                            }
                        }


                        // last N matches
                        if (home5yearsStats.length > 0 && away5yearsStats.length > 0) {
                            let home_last_20_events = home5yearsStats[0].home_last_20_events;
                            let away_last_20_events = away5yearsStats[0].away_last_20_events;

                            let home_last_10_events = home_last_20_events;
                            let away_last_10_events = away_last_20_events;
                            let home_last_5_events = home_last_20_events;
                            let away_last_5_events = away_last_20_events;
                            if (home_last_10_events.length > 10)
                                home_last_10_events = home_last_20_events.slice(-10);
                            if (away_last_10_events.length > 10)
                                away_last_10_events = away_last_20_events.slice(-10);
                            if (home_last_5_events.length > 5)
                                home_last_5_events = home_last_20_events.slice(-5);
                            if (away_last_5_events.length > 5)
                                away_last_5_events = away_last_20_events.slice(-5);

                            let event_list = [home_last_20_events, away_last_20_events, home_last_10_events, away_last_10_events, home_last_5_events, away_last_5_events];
                            for (let index=0; index<event_list.length; index++) {
                                let events = event_list[index];

                                let count_05_ht = 0;
                                let count_15_ft = 0;
                                let count_25_ft = 0;
                                let count_bts = 0;
                                let count_0_to_15 = 0;
                                let count_79_to_90 = 0;

                                var total_matches = 0;

                                var home_win_count = 0;
                                var draw_win_count = 0;
                                var away_win_count = 0;

                                var total_goals = 0;
                                var total_firsthalf_goals = 0;
                                var total_secondhalf_goals = 0;

                                var first_05_count = 0;
                                var first_15_count = 0;
                                var first_25_count = 0;

                                var full_05 = 0;
                                var full_15 = 0;
                                var full_25 = 0;
                                var full_35 = 0;
                                var full_45 = 0;

                                var bts_count = 0;

                                var goal_bands_15_count = 0;
                                var goal_bands_30_count = 0;
                                var goal_bands_45_count = 0;
                                var goal_bands_60_count = 0;
                                var goal_bands_75_count = 0;
                                var goal_bands_90_count = 0;

                                var fts_h = 0;
                                var fts_hw = 0;
                                var fts_a = 0;
                                var fts_aw = 0;

                                var odds_list = [];

                                var home_score_count = 0;
                                var away_score_count = 0;
                                var second_05_count = 0;
                                var second_15_count = 0;
                                var second_25_count = 0;

                                let event_ids = [];
                                for (let _event of events) {
                                    event_ids.push(_event.id);
                                    var home_ht_goals_ = 0
                                    var away_ht_goals_ = 0

                                    var home_ft_goals_ = 0
                                    var away_ft_goals_ = 0 

                                    var home_2_ht_goals_ = 0
                                    var away_2_ht_goals_ = 0 

                                    var first_half_goal = 0;
                                    var full_match_goals = 0;
                                    var second_half_goal = 0;
                                    var home_goals = 0;
                                    var away_goals = 0;

                                    var event_goal_bands_15_count = 0;
                                    var event_goal_bands_30_count = 0;
                                    var event_goal_bands_45_count = 0;
                                    var event_goal_bands_60_count = 0;
                                    var event_goal_bands_75_count = 0;
                                    var event_goal_bands_90_count = 0;

                                    var fts_h_ = 0;
                                    var fts_hw_ = 0;
                                    var fts_a_ = 0;
                                    var fts_aw_ = 0;

                                    var localteam_id_ = _event.localteam_id
                                    var visitorteam_id_ = _event.visitorteam_id;

                                    for (var g = 0; g < _event.goals.data.length; g++) {
                                        let goal =  _event.goals.data[g];
                                        if ( g == 0 && goal.minute < 91) {
                                            if (goal.team_id == localteam_id_) {
                                                fts_h_ = 1;
                                            }
                                            else if (goal.team_id == visitorteam_id_) {
                                                fts_a_ = 1;
                                            }
                                        }
                                        if ( goal.minute <= 45 ) {
                                            if (localteam_id_ == goal.team_id){
                                                home_ht_goals_ += 1;
                                                home_ft_goals_ += 1;
                                                
                                            }
                                            else{
                                                away_ht_goals_ += 1;
                                                away_ft_goals_ += 1;                                                
                                            }
                                            first_half_goal += 1;
                                            total_firsthalf_goals += 1;
                                            full_match_goals += 1;
                                            total_goals += 1;
                                        }
                                        else if ( goal.minute <= 90 ){
                                            if (localteam_id_ == goal.team_id){
                                                home_2_ht_goals_ += 1;
                                                home_ft_goals_ += 1;                                                
                                            }
                                            else{
                                                away_2_ht_goals_ += 1;
                                                away_ft_goals_ += 1;
                                            }
                                            second_half_goal += 1;
                                            total_secondhalf_goals += 1;
                                            full_match_goals += 1;
                                            total_goals += 1;
                                        }

                                        if (goal.minute < 16) {
                                            event_goal_bands_15_count = 1;
                                        }
                                        else if (goal.minute < 31) {
                                            event_goal_bands_30_count = 1;                                            
                                        }
                                        else if (goal.minute < 46) {
                                            event_goal_bands_45_count = 1;                                            
                                        }
                                        else if (goal.minute < 61) {
                                            event_goal_bands_60_count = 1;                                            
                                        }
                                        else if (goal.minute < 76) {
                                            event_goal_bands_75_count = 1;                                             
                                        }
                                        else if (goal.minute < 91) {
                                            event_goal_bands_90_count = 1;                                            
                                        }
                                    }

                                    if (fts_h_ == 1) {
                                        fts_h += 1;
                                        if ( home_ft_goals_ > away_ft_goals_ ) {
                                            fts_hw += 1;
                                        }  
                                    }
                                    if (fts_a_ == 1) {
                                        fts_a += 1;
                                        if ( home_ft_goals_ < away_ft_goals_ ) {
                                            fts_aw += 1;
                                        }  
                                    }
                                    goal_bands_15_count += event_goal_bands_15_count;
                                    goal_bands_30_count += event_goal_bands_30_count;
                                    goal_bands_45_count += event_goal_bands_45_count;
                                    goal_bands_60_count += event_goal_bands_60_count;
                                    goal_bands_75_count += event_goal_bands_75_count;
                                    goal_bands_90_count += event_goal_bands_90_count;

                                    if ( home_ft_goals_ > away_ft_goals_ ) {
                                        home_win_count += 1;
                                    }
                                    else if ( home_ft_goals_ < away_ft_goals_ ) {
                                        away_win_count += 1;
                                    }
                                    else {
                                        draw_win_count += 1;
                                    }

                                    if (first_half_goal == 1) {
                                        first_05_count += 1;
                                    }
                                    else if (first_half_goal == 2) {
                                        first_05_count += 1;
                                        first_15_count += 1;
                                    }
                                    else if (first_half_goal > 2) {
                                        first_05_count += 1;
                                        first_15_count += 1;
                                        first_25_count += 1;
                                    }
                                    if (second_half_goal == 1) {
                                        second_05_count += 1;
                                    }
                                    else if (second_half_goal == 2) {
                                        second_05_count += 1;
                                        second_15_count += 1;
                                    }
                                    else if (second_half_goal > 2) {
                                        second_05_count += 1;
                                        second_15_count += 1;
                                        second_25_count += 1;
                                    }

                                    if (home_ft_goals_ > 0) {
                                        home_score_count += 1;
                                    }
                                    if (away_ft_goals_ > 0) {
                                        away_score_count += 1;
                                    }

                                    if (full_match_goals == 1) {
                                        full_05 += 1;
                                    }
                                    else if (full_match_goals == 2) {
                                        full_05 += 1;
                                        full_15 += 1;
                                    }
                                    else if (full_match_goals == 3) {
                                        full_05 += 1;
                                        full_15 += 1;
                                        full_25 += 1;
                                    }
                                    else if (full_match_goals == 4) {
                                        full_05 += 1;
                                        full_15 += 1;
                                        full_25 += 1;
                                        full_35 += 1;
                                    }
                                    else if (full_match_goals > 4) {
                                        full_05 += 1;
                                        full_15 += 1;
                                        full_25 += 1;
                                        full_35 += 1;
                                        full_45 += 1;
                                    }
                                    if (home_ft_goals_ > 0 && away_ft_goals_ > 0) {
                                        bts_count += 1;
                                    }
                                }

                                let num_matches =  events.length
                                let stats = {
                                    event_ids: event_ids,
                                    total_matches: num_matches,
                                    home_win_percent: parseInt(100 * (home_win_count / num_matches)),
                                    draw_win_percent: parseInt(100 * (draw_win_count / num_matches)),
                                    away_win_percent: parseInt(100 * (away_win_count / num_matches)),
                                    avg_firsthalf_goals_percent:  Number((total_firsthalf_goals / num_matches).toFixed(2)),
                                    avg_secondhalf_goals_percent: Number((total_secondhalf_goals / num_matches).toFixed(2)),
                                    avg_total_goals_percent: Number((total_goals / num_matches).toFixed(2)),
                                    home_score_percent: parseInt(100 * (home_score_count / num_matches)),
                                    away_score_percent: parseInt(100 * (away_score_count / num_matches)),
                                    first_05_percent: parseInt(100 * (first_05_count / num_matches)),
                                    first_15_percent: parseInt(100 * (first_15_count / num_matches)),
                                    first_25_percent: parseInt(100 * (first_25_count / num_matches)),
                                    second_05_percent: parseInt(100 * (second_05_count / num_matches)),
                                    second_15_percent: parseInt(100 * (second_15_count / num_matches)),
                                    second_25_percent: parseInt(100 * (second_25_count / num_matches)),
                                    full_05_percent: parseInt(100 * (full_05 / num_matches)),
                                    full_15_percent: parseInt(100 * (full_15 / num_matches)),
                                    full_25_percent: parseInt(100 * (full_25 / num_matches)),
                                    full_35_percent: parseInt(100 * (full_35 / num_matches)),
                                    full_45_percent: parseInt(100 * (full_45 / num_matches)),
                                    bts_percent: parseInt(100 * (bts_count / num_matches)),
                                    goal_bands_15_percent: parseInt(100 * (goal_bands_15_count / num_matches)),
                                    goal_bands_30_percent: parseInt(100 * (goal_bands_30_count / num_matches)),
                                    goal_bands_45_percent: parseInt(100 * (goal_bands_45_count / num_matches)),
                                    goal_bands_60_percent: parseInt(100 * (goal_bands_60_count / num_matches)),
                                    goal_bands_75_percent: parseInt(100 * (goal_bands_75_count / num_matches)),
                                    goal_bands_90_percent: parseInt(100 * (goal_bands_90_count / num_matches)),
                                    fts_h_percent: Number((100 * (fts_h / num_matches)).toFixed(2)),
                                    fts_hw_percent: fts_h ? Number((100 * (fts_hw / fts_h)).toFixed(2)) : 0,
                                    fts_a_percent: Number((100 * (fts_a / num_matches)).toFixed(2)),
                                    fts_aw_percent: fts_a ? Number((100 * (fts_aw / fts_a)).toFixed(2)) : 0,
                                }

                                if (index == 0) {
                                    this.last_20_matches[0] = {
                                        ...this.last_20_matches[0],
                                        ...stats
                                    }
                                }
                                else if (index == 1) {
                                    this.last_20_matches[1] = {
                                        ...this.last_20_matches[1],
                                        ...stats
                                    }
                                }
                                else if (index == 2) {
                                    this.last_10_matches[0] = {
                                        ...this.last_10_matches[0],
                                        ...stats
                                    }
                                }
                                else if (index == 3) {
                                    this.last_10_matches[1] = {
                                        ...this.last_10_matches[1],
                                        ...stats
                                    }
                                }
                                else if (index == 4) {
                                    this.last_5_matches[0] = {
                                        ...this.last_5_matches[0],
                                        ...stats
                                    }
                                }
                                else if (index == 5) {
                                    this.last_5_matches[1] = {
                                        ...this.last_5_matches[1],
                                        ...stats
                                    }
                                }
                            }

                            this.last_20_matches[2] = this.getChance(this.last_20_matches[0], this.last_20_matches[1]);
                            this.last_20_matches[3] = this.getImpliedOdds(this.last_20_matches[2]);

                            this.last_10_matches[2] = this.getChance(this.last_10_matches[0], this.last_10_matches[1]);
                            this.last_10_matches[3] = this.getImpliedOdds(this.last_10_matches[2]);

                            this.last_5_matches[2] = this.getChance(this.last_5_matches[0], this.last_5_matches[1]);
                            this.last_5_matches[3] = this.getImpliedOdds(this.last_5_matches[2]);
                        }
                    }
                }
                this.items1 = items1;
                this.items2 = items2;
            }).finally(() => {
                this.hideModal();
                this.loading = false;
            });            
        },
        showModal() {
            // this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')            
            this.$bvModal.show('modal-1')
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        },
        getChance(item1, item2) {
            let chance = {
                name: this.$t('Chance') + ":",
                total_matches: '',
                home_win_percent: (item1.home_win_percent + item2.home_win_percent) / 2,
                draw_win_percent: (item1.draw_win_percent + item2.draw_win_percent) / 2,
                away_win_percent: (item1.away_win_percent + item2.away_win_percent) / 2,
                avg_firsthalf_goals_percent: Number(((item1.avg_firsthalf_goals_percent + item2.avg_firsthalf_goals_percent) / 2).toFixed(2)),
                avg_secondhalf_goals_percent: Number(((item1.avg_secondhalf_goals_percent + item2.avg_secondhalf_goals_percent) / 2).toFixed(2)),
                avg_total_goals_percent: Number(((item1.avg_total_goals_percent + item2.avg_total_goals_percent) / 2).toFixed(2)),
                home_score_percent: (item1.home_score_percent + item2.home_score_percent) / 2,
                away_score_percent: (item1.away_score_percent + item2.away_score_percent) / 2,
                first_05_percent: (item1.first_05_percent + item2.first_05_percent) / 2,
                first_15_percent: (item1.first_15_percent + item2.first_15_percent) / 2,
                first_25_percent: (item1.first_25_percent + item2.first_25_percent) / 2,
                second_05_percent: (item1.second_05_percent + item2.second_05_percent) / 2,
                second_15_percent: (item1.second_15_percent + item2.second_15_percent) / 2,
                second_25_percent: (item1.second_25_percent + item2.second_25_percent) / 2,
                full_05_percent: (item1.full_05_percent + item2.full_05_percent) / 2,
                full_15_percent: (item1.full_15_percent + item2.full_15_percent) / 2,
                full_25_percent: (item1.full_25_percent + item2.full_25_percent) / 2,
                full_35_percent: (item1.full_35_percent + item2.full_35_percent) / 2,
                full_45_percent: (item1.full_45_percent + item2.full_45_percent) / 2,
                bts_percent: (item1.bts_percent + item2.bts_percent) / 2,
                goal_bands_15_percent: (item1.goal_bands_15_percent + item2.goal_bands_15_percent) / 2,
                goal_bands_30_percent: (item1.goal_bands_30_percent + item2.goal_bands_30_percent) / 2,
                goal_bands_45_percent: (item1.goal_bands_45_percent + item2.goal_bands_45_percent) / 2,
                goal_bands_60_percent: (item1.goal_bands_60_percent + item2.goal_bands_60_percent) / 2,
                goal_bands_75_percent: (item1.goal_bands_75_percent + item2.goal_bands_75_percent) / 2,
                goal_bands_90_percent: (item1.goal_bands_90_percent + item2.goal_bands_90_percent) / 2,
                fts_h_percent: Number(((item1.fts_h_percent + item2.fts_h_percent) / 2).toFixed(2)),
                fts_hw_percent: Number(((item1.fts_hw_percent + item2.fts_hw_percent) / 2).toFixed(2)),
                fts_a_percent: Number(((item1.fts_a_percent + item2.fts_a_percent) / 2).toFixed(2)),
                fts_aw_percent: Number(((item1.fts_aw_percent + item2.fts_aw_percent) / 2).toFixed(2)),
            };
            return chance;
        },
        getImpliedOdds(item) {
            let chance = {
                name: this.$t("Implied Odds")+":",
                total_matches: '',
                home_win_percent: (100 / item.home_win_percent).toFixed(2),
                draw_win_percent: (100 / item.draw_win_percent).toFixed(2),
                away_win_percent: (100 / item.away_win_percent).toFixed(2),
                avg_firsthalf_goals_percent: "",
                avg_secondhalf_goals_percent: "",
                avg_total_goals_percent: "",
                home_score_percent: (100 / item.home_score_percent).toFixed(2),
                away_score_percent: (100 / item.away_score_percent).toFixed(2),
                first_05_percent:(100 / item.first_05_percent).toFixed(2),
                first_15_percent: (100 / item.first_15_percent).toFixed(2),
                first_25_percent:(100 / item.first_25_percent).toFixed(2),
                second_05_percent:(100 / item.second_05_percent).toFixed(2),
                second_15_percent: (100 / item.second_15_percent).toFixed(2),
                second_25_percent: (100 / item.second_25_percent).toFixed(2),
                full_05_percent: (100 / item.full_05_percent).toFixed(2),
                full_15_percent: (100 / item.full_15_percent).toFixed(2),
                full_25_percent: (100 / item.full_25_percent).toFixed(2),
                full_35_percent: (100 / item.full_35_percent).toFixed(2),
                full_45_percent: (100 / item.full_45_percent).toFixed(2),
                bts_percent: (100 / item.bts_percent).toFixed(2),
                goal_bands_15_percent: "",
                goal_bands_30_percent: "",
                goal_bands_45_percent: "",
                goal_bands_60_percent: "",
                goal_bands_75_percent: "",
                goal_bands_90_percent: "",
                fts_h_percent: (100 / item.fts_h_percent).toFixed(2),
                fts_hw_percent: (100 / item.fts_hw_percent).toFixed(2),
                fts_a_percent: (100 / item.fts_a_percent).toFixed(2),
                fts_aw_percent: (100 / item.fts_aw_percent).toFixed(2),
            };
            return chance;
        }
    }
}
</script>
<style scoped>

.table-responsive {
    max-height: 80vh !important;
    margin-top: 20px !important;
}
.roi-cell {
    color: black;
    border-radius: 5px;
    padding: 5px;
}
.underline-dec {
    text-decoration: underline;
}

</style>
<style>

.table-responsive {
    max-height: 80vh !important;
    margin-top: 20px;
}
.statistic_table_modify > .table-responsive{
    margin-top: 20px !important;
}

thead {
    padding: 3px;
    position: sticky;
    top: 0;
    z-index: 1;
    /* width: 25vw; */
    background: white;
}
.first_tr{
    background-color: #bae1aa ;
}

.table_first_tr {
    background-color: #6aa807; color: white;
}

.table_first_tr + tr{
    background-color: #99c08e;
    color: white;
}

.left_align {
    text-align: left !important;
}
.team_stats_table th {
    padding-left: 5px !important; 
    padding-right: 5px !important;
}
.team_stats_table td {
    padding-left: 5px !important; 
    padding-right: 5px !important;
}
.background-white {
    background-color: white;
}
.background-green {
    background-color: green;
    color: white;
}
.color-dark {
    color: black;
    font-weight: 600;
}
</style>